import { AreaWithNestedJsonInfo, IMapState } from 'types/map';

export default function setCurrentArea(state: IMapState, payload: { area: AreaWithNestedJsonInfo }) {
  const { area } = payload;
  const { moveMessage, showOps } = payload.area;
  return {
    ...state,
    currentArea: { ...area, ...(area.jsonInfo ?? {})}, // currentArea needs jsonInfo too
    moveMessage,
    showOps,
  };
}